import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const ROLE_LABELS = {
  admin: "Administrateur",
  dirigeant: "Dirigeant",
  manager_commercial: "Manager Commercial",
  vendeur: "Vendeur",
  secretaire_bo: "Secrétaire BackOffice",
  responsable_facturation: "Responsable Facturation",
};

export const PROSPECT_STATUSES = [
  { value: "nouveau", label: "Nouveau", color: "text-blue-700 bg-blue-50 border-blue-200" },
  { value: "a_relancer", label: "À relancer", color: "text-amber-700 bg-amber-50 border-amber-200" },
  { value: "rdv_planifie", label: "RDV planifié", color: "text-indigo-700 bg-indigo-50 border-indigo-200" },
  { value: "chaud", label: "Chaud", color: "text-orange-700 bg-orange-50 border-orange-200" },
  { value: "option_demandee", label: "Option demandée", color: "text-purple-700 bg-purple-50 border-purple-200" },
  { value: "vente_en_cours", label: "Vente en cours", color: "text-teal-700 bg-teal-50 border-teal-200" },
  { value: "signe", label: "Signé", color: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  { value: "perdu", label: "Perdu", color: "text-red-700 bg-red-50 border-red-200" },
  { value: "non_avere", label: "Non avéré", color: "text-slate-600 bg-slate-100 border-slate-300" },
  { value: "sans_suite", label: "Sans suite", color: "text-stone-600 bg-stone-100 border-stone-300" },
];

export const DOSSIER_STATUSES = [
  { value: "signe", label: "Signé" },
  { value: "denonciation_envoyee", label: "Dénonciation envoyée" },
  { value: "option_envoyee", label: "Option envoyée" },
  { value: "financement_en_cours", label: "Financement en cours" },
  { value: "financement_ok", label: "Financement OK" },
  { value: "notaire_planifie", label: "Notaire planifié" },
  { value: "notaire_signe", label: "Notaire signé" },
  { value: "facture_envoyee", label: "Facture envoyée" },
  { value: "facture_payee", label: "Facture payée" },
  { value: "cloture", label: "Clôturé" },
];

export const FINANCEMENT_STATUSES = [
  { value: "en_attente", label: "En attente" },
  { value: "en_cours", label: "En cours" },
  { value: "obtenu", label: "Obtenu" },
  { value: "refuse", label: "Refusé" },
];

export const DENONCIATION_STATUSES = [
  { value: "a_traiter", label: "À traiter" },
  { value: "envoyee", label: "Envoyée" },
  { value: "acceptee", label: "Acceptée" },
  { value: "refusee", label: "Refusée" },
];

export const OPTION_STATUSES = [
  { value: "a_traiter", label: "À traiter" },
  { value: "demandee", label: "Demandée" },
  { value: "accordee", label: "Accordée" },
  { value: "refusee", label: "Refusée" },
];

export const FACTURE_STATUSES = [
  { value: "a_emettre", label: "À émettre" },
  { value: "envoyee", label: "Envoyée" },
  { value: "payee", label: "Payée" },
  { value: "en_retard", label: "En retard" },
];

export function formatEUR(v) {
  if (v == null || isNaN(v)) return "—";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v);
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("fr-FR");
}
